import React from "react";
import { RATINGS, RATING_LETTER, RATING_LABEL } from "../../lib/ratings";
import "./Reviews.css";

// The five-swatch rating picker.
//
// Each swatch carries a letter as well as a colour, deliberately: assessments get
// printed in greyscale more often than anyone expects, and roughly one man in twelve
// cannot separate the red from the green. The letter is the real label; the colour is
// reinforcement.
const RatingPicker = ({ value, onChange, disabled, itemName }) => (
  <span className="v2-ratings" role="radiogroup" aria-label={`Rating for ${itemName}`}>
    {RATINGS.map((rating) => (
      <button
        key={rating}
        type="button"
        role="radio"
        aria-checked={value === rating}
        aria-label={RATING_LABEL[rating]}
        title={RATING_LABEL[rating]}
        disabled={disabled}
        className={`v2-rsw v2-rsw--${rating}${value === rating ? " on" : ""}`}
        onClick={() => onChange(rating)}
      >
        {RATING_LETTER[rating]}
      </button>
    ))}
  </span>
);

export default RatingPicker;
